<template>
  <div class="list-editor">
    <div v-if="edited" class="edit-shield" @click="saveEditsReminder"></div>
    <MainBackButton />

    <p class="header">
      <span @click="instructions">List Editor</span>
      <span class="is-pulled-right">
        <i class="fa fa-info-circle has-text-grey" @click="instructions" />
      </span>
    </p>

    <div class="page-region">
      <div v-if="!region">
        <i class="fa fa-globe-asia" style="margin-right: 9px" />Select Region
      </div>
      <div v-if="pageRegion" @click="clearPageRegion">
        <i class="fa fa-chevron-left" />&nbsp;
        {{ pageRegionString }}
        <i
          class="fa fa-external-link-alt has-text-link is-pulled-right"
          style="padding: 3px"
          @click="gotoList"
        />
      </div>
      <div v-else-if="region" @click="region = null">
        <i class="fa fa-chevron-left" />&nbsp;
        {{ region.name }}
        <!-- <i class="fa fa-chevron-right" style="margin: 0 6px" /> -->
        <!-- <i class="fa fa-newspaper" style="margin: 0 6px" />Select Page -->
        <!-- <span class="link is-pulled-right has-text-grey">Change</span> -->
      </div>
    </div>

    <div v-if="!pageRegion" class="list-btns no-scrollbar">
      <div v-if="!region">
        <a
          v-for="r in regions"
          :key="r.name"
          class="button"
          @click="region = r"
        >
          {{ r.name }}
        </a>
      </div>
      <div v-else>
        <a v-for="p in pages" :key="p" class="button" @click="setPage(p)">
          {{ p }}
        </a>
        <p style="margin-top: 18px" @click="createNewPage">
          <span class="link has-text-success"
            ><i class="fa fa-plus-circle fa-sm" />&nbsp;Create New
          </span>
        </p>
      </div>
    </div>

    <div v-if="pageRegion">
      <div v-if="loading" class="centered">
        <!-- <div class="tuk-icon centered"></div> -->
        <half-circle-spinner
          :animation-duration="1200"
          :size="190"
          color="#209CEE"
        />
      </div>

      <div v-else>
        <section class="notification no-scrollbar" :key="z">
          <div
            v-if="title.settings && title.settings.hidden"
            style="background-color: pink; padding: 6px"
            @click="showSettings = true"
          >
            List is HIDDEN
          </div>
          <div class="title-editor">
            <div v-if="editTitle">
              List Title:
              <div
                v-for="l in languages"
                :key="l"
                class="is-uppercase"
                style="margin-bottom: 4px"
              >
                <div class="field has-addons is-fullwidth">
                  <p class="control">
                    <a
                      class="button is-uppercase"
                      style="display: inline-block; width: 60px"
                      >{{ l }}</a
                    >
                  </p>
                  <div class="control is-expanded">
                    <input v-model="title.lang[l]" class="input" />
                  </div>
                </div>
              </div>
              <div class="has-text-right" style="margin-top: 4px">
                <span class="button is-success" @click="saveTitle">Save</span
                >&nbsp;
                <span class="button" @click="editTitle = false">Cancel</span>
              </div>
            </div>
            <div v-else>
              <span>List Title:</span>&nbsp;
              <span class="link has-text-weight-bold" @click="editTitle = true">
                <span v-if="title.lang.en">{{ title.lang.en }}</span>
                <span v-else>{{ page }} (default)</span>
              </span>
              <span
                v-if="title.settings"
                class="tag is-grey"
                @click="showSettings = true"
              >
                <span style="margin-right: 6px">{{
                  title.settings.label
                }}</span>
                <i
                  v-if="title.settings.randomise"
                  class="fa fa-random"
                  style="margin-right: 6px"
                />
                <i
                  v-if="title.settings.time_slot"
                  class="far fa-clock"
                  style="margin-right: 6px"
                />
                <span class="tag is-white is-rounded">
                  <i class="fa fa-pencil-alt fa-sm has-text-info" />
                </span>
              </span>
              <span
                class="is-pulled-right link"
                style="font-size: 0.9em"
                @click="toggleGripLines"
                >Re-order <i class="fa fa-grip-lines" style="padding: 4px" />
              </span>
            </div>
          </div>

          <div style="background-color: white; padding: 5px">
            <span class="button is-rounded has-text-success" @click="addList">
              <i class="fa fa-plus-circle" />&nbsp;Create
            </span>
          </div>

          <draggable
            v-model="lists"
            handle=".handle"
            @start="drag = true"
            @end="drag = false"
            @change="setRanks"
          >
            <div v-for="(o, i) in lists" :key="i">
              <div
                class="columns is-mobile is-vcentered outer"
                :class="{ 'bg-hidden': o.hidden }"
              >
                <div
                  v-if="o.pic"
                  class="column is-narrow"
                  @click="editPic(i, false)"
                >
                  <img v-webp="o.pic" @error="defaultImg" class="main-img" />
                </div>
                <div v-else class="column is-narrow" @click="editPic(i, true)">
                  <div class="no-pic-box" />
                  <i class="fa fa-camera-retro no-pic has-text-success" />
                </div>
                <div
                  class="column has-text-left"
                  :class="{ 'pad-right': !showGripLines }"
                >
                  <p v-if="o.name" class="has-text-weight-medium">
                    <span
                      @click="
                        o._name = o.name;
                        o.name = null;
                      "
                    >
                      <span class="is-size-5 link">{{ o.name }}</span>
                    </span>
                    <!-- <span class="is-pulled-right">
                      <span @click="toggleShowName(o)">
                        <i
                          v-if="o.show_name"
                          class="fa fa-eye has-text-success fa-sm"
                        />
                        <i v-else class="fa fa-eye-slash has-text-grey fa-sm" />
                      </span> -->
                    <!-- &nbsp;
                      <i
                        class="fa fa-trash-alt has-text-grey"
                        style="opacity: 0.4"
                        @click="deleteList(o)"
                      /> -->
                    <!-- </span> -->
                  </p>
                  <p v-else class="control has-icons-right">
                    <span
                      class="icon is-small is-right"
                      style="pointer-events: initial"
                      v-show="true"
                      @click="o.name = o._name"
                    >
                      <i class="fa fa-check-circle has-text-success" />
                    </span>
                    <input
                      class="input"
                      v-model="o._name"
                      placeholder="List Name"
                      @keydown="edited = true"
                      @keyup.enter="o.name = o._name"
                    />
                  </p>
                  <div v-if="o.tag" class="has-text-weight-medium">
                    <p
                      class="tag-text"
                      @click="
                        o._tag = o.tag;
                        o.tag = null;
                      "
                    >
                      {{ o.tag }}
                    </p>
                    <!-- <i
                      class="fa fa-share-alt is-pulled-right has-text-info"
                      @click="shareList(o)"
                    /> -->
                    <!-- <i
                      class="fa fa-trash-alt delete-list"
                      style="opacity: 0.4"
                      @click="deleteList(o)"
                    /> -->
                  </div>
                  <p v-else class="control has-icons-right">
                    <span
                      class="icon is-small is-right"
                      style="pointer-events: initial"
                      v-show="true"
                      @click="o.tag = o._tag"
                    >
                      <i class="fa fa-check-circle has-text-info" />
                    </span>
                    <input
                      class="input"
                      v-model="o._tag"
                      placeholder="Tag: Drinks, _aug"
                      @keydown="edited = true"
                      @keyup.enter="o.tag = o._tag"
                    />
                  </p>
                </div>
                <div class="column is-narrow btns">
                  <p class="toggle-eye">
                    <span @click="toggleShowName(o)">
                      <i
                        v-if="o.show_name"
                        class="fa fa-eye has-text-success fa-sm"
                      />
                      <i v-else class="fa fa-eye-slash has-text-grey fa-sm" />
                    </span>
                  </p>
                  <!-- <p class="delete-list">
                    <i class="far fa-trash-alt" @click="deleteList(o)" />
                  </p> -->
                  <p class="delete-list">
                    <i class="fa fa-cog" @click="showMore = o" />
                  </p>
                </div>
                <div
                  v-if="showGripLines"
                  class="column is-narrow has-text-left"
                >
                  <p
                    v-if="o.name"
                    class="tag is-medium handle"
                    style="padding: 10px; margin: 4px"
                  >
                    <span class="has-text-black is-grey">{{ o.rank }}</span
                    >&nbsp;
                    <i class="fa fa-grip-lines has-text-success fa-lg" />
                  </p>
                  <p
                    v-else
                    style="padding: 6px; padding-right: 14px"
                    @click="deleteList(o)"
                  >
                    <i class="fa fa-trash-alt has-text-grey" />
                  </p>
                </div>
              </div>
              <div
                v-if="showDetails && picIndex === i"
                class="details-wrapper"
                :class="{ 'is-flex': flexView }"
                :key="zz"
              >
                <div class="has-text-grey">
                  <i
                    class="fa fa-chevron-up close-details"
                    @click="showDetails = false"
                  />
                  <i class="fa fa-list toggle-view" @click="toggleView" />
                </div>
                <div
                  v-for="l in languages"
                  :key="l"
                  class="lang-pic"
                  @click="lang = l"
                >
                  <div class="column is-narrow">
                    <p class="is-uppercase">{{ l }}</p>
                    <div @click="editPic(i, true)">
                      <div v-if="o[`pic_${l}`]">
                        <img
                          v-webp="o[`pic_${l}`]"
                          @error="defaultImg"
                          :class="{ 'width-auto': !flexView }"
                        />
                      </div>
                      <div v-else style="width: 100%">
                        <div
                          class="no-pic-box"
                          style="background-color: #ccc"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </draggable>

          <!-- <div class="has-text-centered" style="margin: 0">
            <i class="far fa-window-minimize has-text-grey" />
          </div> -->

          <!-- <div style="margin: 9px">
            <span class="link has-text-success" @click="addList">
              <i class="fa fa-plus-circle" />&nbsp;Create
            </span>
          </div> -->
        </section>

        <div class="bottom-buttons">
          <span
            class="button is-white is-rounded settings"
            @click="showSettings = true"
          >
            <i class="fa fa-cog" />
          </span>
          <a class="button is-rounded is-primary" @click="saveBlobs">
            <i class="fa fa-save" />&nbsp; Save</a
          >
          <span v-if="edited" class="reminder">Edited</span>
        </div>

        <input
          type="file"
          ref="file"
          style="display: none"
          accept="image/png,image/jpeg,image/jpg,image/bmp"
          @change="uploadPic($event)"
        />

        <ListEditorSettings
          v-if="showSettings"
          :blob="title.blob"
          @save="saveSettings"
          @close="showSettings = false"
        />

        <ListEditorMore
          v-if="showMore"
          :list="showMore"
          @delete="deleteList"
          @save="saveShowMore"
          @close="closeShowMore"
        />
      </div>
    </div>
  </div>
</template>


<script>
import MainBackButton from "@/components/MainBackButton";
import ListEditorSettings from "@/components/ListEditorSettings";
import ListEditorMore from "@/components/ListEditorMore";

import { HalfCircleSpinner } from "epic-spinners";
import draggable from "vuedraggable";
import imageCompression from "browser-image-compression";
const shortid = require("shortid");

export default {
  name: "ListEditor",
  components: {
    MainBackButton,
    ListEditorSettings,
    ListEditorMore,
    HalfCircleSpinner,
    draggable,
  },
  data() {
    return {
      showMore: null, // list object to view more options of
      showSettings: false,
      showGripLines: false,
      editTitle: false,
      flexView: true,
      regions: [
        {
          name: "Chiang Mai",
          code: "cm",
        },
        { name: "Chiang Rai", code: "cr" },
        { name: "Bangkok", code: "bk" },
        { name: "Singapore", code: "sg" },
        { name: "Lisbon", code: "lb" },
      ],
      pages: [
        "Eat",
        "Shop",
        "Services",
        "Home",
        "Home_1",
        "Home_2",
        "Home_3",
        "Home_4",
        "Home_5",
        "Home_6",
        "Home_7",
        "Home_8",
        "Home_9",
        "Home_10",
        "Home_11",
        "Home_12",
        "Home_Business",
      ],
      region: null,
      page: null,
      pageRegions: [
        { page: "Eat", region: "Chiang Mai" },
        { page: "Eat", region: "Bangkok" },
        { page: "Eat", region: "Singapore" },
        { page: "Shop", region: "Chiang Mai" },
        { page: "Shop", region: "Bangkok" },
        { page: "Shop", region: "Singapore" },
        { page: "Services", region: "Chiang Mai" },
        { page: "Services", region: "Bangkok" },
        { page: "Services", region: "Singapore" },
      ],
      title: { lang: {} },
      // pageRegion: null,
      lists: [],
      maxLists: 20,
      picIndex: 0,
      edited: false,
      lang: "en", // default lang
      languages: ["en", "th", "zh", "ja"],
      showDetails: false,
      z: 0,
      zz: 0,
      loading: false,
      loaderSize: Math.min(window.innerWidth * 0.75, window.innerHeight * 0.75),
    };
  },
  computed: {
    superuser() {
      return this.$store.getters.isSuperUser;
    },
    pageRegionString() {
      if (!this.region || !this.page) return null;
      return `${this.region.name} - ${this.page}`;
    },
    pageRegion() {
      if (!this.region || !this.page) return null;
      return {
        page: this.page,
        region: this.region.name,
      };
    },
    // selectedPageRegionString() {
    //   if (!this.pageRegion) return;
    //   // return this.pageRegion.page + " > " + this.pageRegion.region;
    //   return this.pageRegion.region + " - " + this.pageRegion.page;
    // },
  },
  methods: {
    closeShowMore() {
      this.showMore = null;
    },
    createNewPage() {
      this.infoToast(
        "Create arbitrary pages/lists<br>Coming soon... Ask me for now"
      );
    },
    saveSettings(settings) {
      console.log("saveSettings", settings);
      this.title.settings = settings;
      this.saveTitle();
    },
    saveShowMore(options) {
      console.log("saveShowMore", options);
      this.showMore.hidden = options.hidden;
    },
    toggleGripLines() {
      this.showGripLines = !this.showGripLines;
    },
    toggleShowName(o) {
      o.show_name = !o.show_name;
      this.z += 1;
      this.edited = true;
      if (o.show_name) this.infoToast("Show list name");
      else this.errorToast("Don't show list name");
    },
    toggleView() {
      this.flexView = !this.flexView;
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    setPage(p) {
      this.page = p;
      this.getBlobs();
    },
    instructions() {
      var blue = this.bulmaColor("info");
      this.$swal({
        title: `<i class="fa fa-info-circle" style="color: ${blue}" />`,
        html: `<div style='text-align:left'>
        <p><i>Lists are simply tags or search terms</i></p>
        <p style='margin-top:10px'>Tags can be of 3 types:</p>
        <p style='margin-top:10px'>
        (1) Special tags:<br><button>*free-delivery</button><button>*discount30</button><br>
        (2) Normal tags:<br><button>italian</button><button>bbq</button><br>
        (3) Hidden tags:<br><button>_paydayAug</button><button>_jklasdf</button>
        </p>
        <p style='margin-top:10px; font-size:0.7em; font-weight:550; opacity:0.6'>
        *Pic is optional, list name will be used as fallback.
        </p>
        </div>`,
        showCloseButton: true,
        showConfirmButton: false,
      });
    },
    clearPageRegion() {
      if (this.edited) {
        this.saveEditsReminder();
      } else {
        this.region = null;
        this.page = null;
        this.editTitle = false;
        // this.title = { lang: {} };
      }
    },
    // changePageRegion() {
    //   if (this.edited) {
    //     this.saveEditsReminder();
    //   } else {
    //     this.pageRegion = null;
    //   }
    // },
    saveEditsReminder() {
      var green = this.bulmaColor("primary");
      this.$swal({
        html: `<div style='text-align:left'>
        <p style='margin-bottom:12px; font-size:1.2em'>
        <i class="fa fa-save"></i>&nbsp;Remember to Save
        </p>
        <p>Do you want to save your list edits before leaving this page?</p>
        </div>`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("save"),
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: green,
      }).then((val) => {
        if (val.value) this.saveBlobs();
        else this.edited = false;
      });
    },
    deleteList(o) {
      var red = this.bulmaColor("danger");
      this.$swal({
        title: `<i class="fa fa-bomb" style="color: ${red}" />`,
        html: `Are you sure you want to soft delete this list?`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: this.$t("cancel"),
        confirmButtonColor: red,
      }).then((val) => {
        if (val.value) {
          // if not saved to DB yet then just remove from array
          if (o.blob) {
            this.$store
              .dispatch("deleteBlob", o.blob.id)
              .then(() => this.getBlobs())
              .catch((err) => this.apiError(err));
          } else {
            this.lists.splice(o.rank - 1, 1); // remove list
            this.setRanks(); // update ranks
          }
        }
      });
    },
    gotoList() {
      if (this.edited) {
        this.saveEditsReminder();
        return;
      }
      // check this.pageRegion, obj like { page: "Eat", region: "Chiang Mai" },
      var page = this.page.toLowerCase();
      var r = this.region.code;
      // var page = this.pageRegion.page.toLowerCase();
      // var r = "cm";
      // var region = this.pageRegion.region;
      // if (region === "Bangkok") r = "bk";
      // if (region === "Singapore") r = "sg";
      this.goto(`/${page}?r=${r}`);
    },
    // setPageRegion(o) {
    //   this.pageRegion = o;
    //   this.getBlobs();
    // },
    setRanks() {
      var changed = false;
      this.lists.forEach((l, i) => {
        if (l.rank != i + 1) changed = true;
        l.rank = i + 1;
      });
      if (changed) {
        this.z += 1;
        this.edited = true;
      }
    },
    addList() {
      if (this.invalidLists()) return;
      if (this.lists.length >= this.maxLists) {
        return this.infoToast(`Max ${this.maxLists} lists per page`);
      }
      this.lists.unshift({
        name: null,
        pic: null,
        tag: null, // search term, underscore _something, or special *free-delivery
        rank: null, // will be set at end of list by setRanks()
        region: this.region.name, //"Chiang Mai",
        page: this.page, //"Eat", // parent_id: eat, parent_type: page
      });
      this.setRanks();
    },
    setLists(arr) {
      arr.forEach((a) => {
        if (a.blob_type === "list_title") {
          this.title.lang = a.data.title;
          this.title.settings = a.data.settings;
          this.title.blob = a;
        } else {
          // otherwise it's a normal list object
          var list = a.data; // a.data should be an object
          list.blob = a; // keep the full blob on list obj
          this.lists.push(list);
        }
      });
      this.setRanks();
    },
    getBlobs() {
      this.loading = true;
      //   var data = { page: "eat", region: "Chiang Mai" };
      this.lists = []; // reset lists before getting new blobs
      this.title = { lang: {} }; // reset title before getting new blobs
      this.$store
        .dispatch("getBlobsForList", this.pageRegion) //"getBlobsForWorkflow", this.role.workflow_id)
        .then((res) => {
          console.log("getBlobsForList", res);
          if (res.data) this.setLists(res.data);
          //this.lists = res.data;
          else {
            this.addList(); // none exist yet, so add one
            // var msg = "No lists found for<br>" + this.selectedPageRegionString;
            var msg = "No lists found for<br>" + this.pageRegionString;
            this.infoToast(msg);
          }
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.loading = false));
    },
    viewLists() {
      if (this.edited) this.saveEditsReminder();
      else this.goto("/eat"); // should go to specific region: /eat?region=Chiang Mai
    },
    invalidLists() {
      for (var i = 0; i < this.lists.length; i++) {
        var l = this.lists[i];
        if (!l.name || !l.tag) {
          var msg = `Invalid lists.<br>Must have name and tag, then click <i class='fa fa-check-circle'></i>`;
          this.errorToast(msg, "top");
          return true;
        }
      }
      return false;
    },
    saveTitle() {
      console.log("saveTitle", this.title);
      var data = {
        region: this.region.name,
        page: this.page,
        title: this.title.lang,
        settings: this.title.settings,
      };
      var o = this.title.blob; // create blob object
      if (!o) {
        o = {
          parent_type: "page",
          parent_id: this.page,
          blob_type: "list_title",
        };
      }
      o.data = data;
      var loader = this.loadingDots("purple");
      this.$store
        .dispatch("saveBlob", o)
        .then(() => {
          this.successToast("Saved list title");
          this.editTitle = false;
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
    saveBlobs() {
      // save array of blobs all at once
      if (this.invalidLists()) return;
      this.loading = true;
      this.lists.forEach((l) => {
        var data = {
          name: l.name,
          pic: l.pic,
          tag: l.tag,
          rank: l.rank,
          region: l.region,
          page: l.page,
          show_name: l.show_name,
          hidden: l.hidden,
        };
        this.languages.forEach((lang) => {
          var k = `pic_${lang}`; // check for pic_en, pic_th, etc keys
          if (l[k]) data[k] = l[k];
        });
        var o = {}; // create blob object
        if (l.blob) {
          o = l.blob; // if existing blob
        } else {
          o = {
            parent_type: "page",
            parent_id: l.page,
            blob_type: "list",
          };
        }
        o.data = data;
        this.saveBlob(o);
      });
      setTimeout(() => {
        this.successToast("Saved lists");
        this.getBlobs(); // update the blobs, needed to pull any new lists' new IDs
      }, 1500);
    },
    saveBlob(o) {
      //   var loader = this.loadingDots("purple");
      this.$store
        .dispatch("saveBlob", o)
        .then(() => {
          this.edited = false;
          //   this.success();
          //   this.successToast("Saved list " + o.data.rank);
        })
        .catch((err) => this.apiError(err));
      // .finally(() => loader.hide());
    },
    shareList(o) {
      this.infoToast("Share list link coming soon!", "top");
      // get the share link for list, tukapp.co/eat?list=fjkljkljklas
    },
    openDetails() {
      if (this.showDetails) {
        this.showDetails = false;
        return;
      }
      this.showDetails = true;
    },
    editPic(idx, force) {
      console.log("editPic", idx);
      this.picIndex = idx; // set idx for use later
      // if (this.showDetails) this.showDetails = false;
      if (force) this.$refs.file.click();
      else this.openDetails(idx);
      // if (this.lists[idx].pic) this.openDetails(idx);
      // else this.$refs.file.click();
    },
    uploadPic(e) {
      if (!e.target.files) return;
      if (e.target.files.length === 0) return;
      var originalFile = e.target.files[0];

      var loader = this.loadingDots();
      var options = {
        maxSizeMB: 0.3,
        maxWidthOrHeight: 400,
        useWebWorker: true,
      };
      imageCompression(originalFile, options)
        .then((compressedFile) => {
          var sizeKB = Math.round(compressedFile.size / 1024);
          this.console(`compressedFile size ${sizeKB} KB`); // smaller than maxSizeMB

          imageCompression
            .getDataUrlFromFile(compressedFile)
            .then((base64) => {
              var data = {
                name: shortid.generate() + ".png",
                content: base64.replace(/^data:image\/[a-z]+;base64,/, ""),
                businessID: "eat_chiang_mai",
                imageType: "list",
              };
              this.$store
                .dispatch("uploadImageAWS", data)
                .then((res) => {
                  console.log("uploadImageAWS", res.data);
                  var url = res.data.compressed_image_url;
                  if (this.lang === "en") this.lists[this.picIndex].pic = url; // set EN as default
                  this.lists[this.picIndex][`pic_${this.lang}`] = url; // set lang specific also pic_en, pic_th
                  this.successToast("Success!", "top");
                  this.lang = "en"; // reset default lang
                  this.zz += 1;
                  // this.save();
                  this.showDetails = true;
                })
                .catch((err) => this.apiError(err))
                .finally(() => loader.hide());
            })
            .catch((err) => this.console("imageData error", err));
        })
        .catch((err) => this.console("imageCompression error", err));
    },
  },
};
</script>

<style scoped>
.list-editor {
  height: 100vh;
  overflow: hidden;
}
.page-region {
  background-color: white;
  padding: 10px;
  text-align: left;
  font-weight: 500;
  box-shadow: 0 2px 4px #bbb;
  margin-bottom: 4px;
}
/* .dark.list-editor,
.dark section {
  background-color: #123;
} */
.header {
  text-align: left;
  padding-left: 55px;
  padding-top: 15px;
  margin-bottom: 12px;
  margin-right: 10px;
  font-size: 1.3em;
}
.subtitle {
  text-align: left;
  margin-left: 10px;
  margin-bottom: 10px;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tuk-icon {
  background-image: url("../../public/img/icons/round-512x512.png");
  position: absolute;
  /* height: min(50vw, 50vh);
  width: min(50vw, 50vh); */
  height: 150px;
  width: 150px;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire */
}
.outer .column {
  padding-left: 7px;
}
.column img {
  /* .main-img { */
  object-fit: cover;
  height: 66px;
  width: 66px;
  border-radius: 3px;
  margin-top: 7px;
  /* box-shadow: 0 0 2px grey; */
  box-shadow: 1px 1px 3px rgba(128, 128, 128, 0.3);
}
.width-auto {
  width: auto !important;
}
.column {
  padding: 0 0;
  /* padding-left: 7px; */
}
.columns {
  position: relative;
  margin: 5px 0;
  padding: 0 0;
  /* border: 1px solid grey; */
  /* border-radius: 6px; */
  box-shadow: 0px 0px 2px rgba(128, 128, 128, 0.2);
  background-color: white;
}
.notification {
  padding: 0px;
  margin: 0 0;
  overflow-y: scroll;
  height: calc(100vh - 110px);
  padding-bottom: 80px;
}
.edit-shield {
  position: absolute;
  top: 0;
  left: 0;
  padding: 30px;
  z-index: 21;
  /* 👆🏻because MainBackButton is z-index = 20 */
}
.bottom-buttons {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 10px;
  background-color: #ddd;
  box-shadow: 0 -3px 3px #aaa;
}
.reminder {
  position: absolute;
  right: 0;
  padding: 8px;
  color: red;
}
.settings {
  position: absolute;
  left: 8px;
  padding: 9px;
}
.button.is-small.is-rounded {
  padding: 0 6px;
  margin-top: 3px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  display: inline-block;
}
.no-pic {
  position: absolute;
  /* left: 33px;
  top: 33px; */
  margin-top: -47px;
  margin-left: -8px;
}
.no-pic-box {
  margin: 6px auto;
  height: 66px;
  width: 66px;
  border-radius: 3px;
  box-shadow: 1px 1px 3px rgba(128, 128, 128, 0.3);
  background-color: rgb(250, 250, 250);
}
.tags {
  padding: 0;
  margin: 0;
}
/* .fa-share-alt {
  margin-top: 14px;
} */
.delete-list {
  color: #999;
  opacity: 0.5;
  position: absolute;
  bottom: 8px;
}
.toggle-eye {
  position: absolute;
  top: 8px;
  opacity: 0.6;
  font-size: 0.9em;
}
.column.btns {
  /* padding: 0 6px; */
  text-align: center;
  width: 30px;
}
.list-btns {
  padding: 10px;
  overflow-y: scroll;
  height: 100%;
  padding-bottom: 200px;
}
.list-btns .button {
  display: block;
  margin-bottom: 10px;
}
.details-wrapper {
  /* margin: 10px; */
  margin-top: -8px;
  padding: 6px;
  padding-top: 12px;
  background-color: rgb(241, 241, 241);
  box-shadow: 0 0 1px #bbb;
  /* display: flex; */
  justify-content: space-around;
  /* align-content: space-around; */
}
.lang-pic {
  /* display: inline-block; */
  text-align: center;
  width: 100%;
}
.link {
  border-bottom: 1px #ccc dotted;
}
.close-details {
  position: absolute;
  left: 6px;
  padding: 6px;
  margin-top: -9px;
  font-size: 1.2em;
}
.toggle-view {
  position: absolute;
  right: 6px;
  padding: 6px;
  margin-top: -6px;
}
.tag {
  padding: 7px;
}
.eye-wrapper {
  position: absolute;
  top: -4px;
  opacity: 0.5;
}
.tag-text {
  display: inline-block;
  margin-top: 3px;
  margin-bottom: 3px;
  padding: 0 3px;
  background-color: #eee;
  border-radius: 4px;
  /* max-width: calc(100vw - 194px); */
  overflow-wrap: anywhere;
}
.title-editor {
  text-align: left;
  padding: 0 12px;
  margin-bottom: 8px;
  margin-top: 8px;
}
.pad-right {
  padding-right: 6px;
}
.bg-hidden {
  background-color: #ccc;
}
</style>